export default function addGoogleAdOnIngridBottomBanner(items, aNoOfProdsPerRow) {
  const googleAdOnIngridBottomItem = {
    googleAdOnIngridBottomBanner: {},
    fullWidth: true,
    excludeRow: true,
  };
  /* istanbul ignore else */
  if (items.length > ((aNoOfProdsPerRow * 5) + 1)) {
    const startIndex = (aNoOfProdsPerRow * 9) + 2;
    return [
      ...items.slice(0, startIndex),
      googleAdOnIngridBottomItem,
      ...items.slice(startIndex),
    ];
  }

  return items;
}
